export const selectText = (node: HTMLElement, start: number, end: number) => {
    const childNode = node.childNodes[0];
    const range = new Range();
    const selection = document.getSelection();
    range.setStart(childNode, start);
    range.setEnd(childNode, end);
    if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
    }
};
